import { createAction, props } from "@ngrx/store";
import { ImplementationViewModel } from "data";

const base = '[Implementation] -';

export const loadImplementationDetails = createAction(`${base} Load Details`);
export const loadImplementationSuccess = createAction(`${base} Load Success`, props<{implementation: ImplementationViewModel}>());
export const loadImplementationFailure = createAction(`${base} Load Failure`, props<{implementation: any}>());
export const updateImplementationStep = createAction(`${base} Update Step`, props<{stepCode: string}>());
